'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["id", "userHover", "isSelectedRichText", "paddingConfig"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCanDeleteElement, getCanCloneElement } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getIsRichTextModule } from 'EmailEditorUI/utils/moduleUtils';
import { getSelectedId } from 'EmailEditorUI/redux/selectors/selected';
import { AsyncElementToolbar } from 'LayoutBuilderUI/components/AsyncComponents';
import { STACK } from 'EmailEditorUI/constants/SectionLayoutConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  return {
    canDeleteElement: getCanDeleteElement(state, ownProps.element),
    canCloneElement: getCanCloneElement(state, ownProps.element.get('module_id'), ownProps.element.get('id')),
    isSelectedRichText: getSelectedId(state) === ownProps.element.get('id') && getIsRichTextModule(ownProps.element)
  };
};
export default function attachEditor(EditableElement) {
  function hasHorizontalPadding(padding) {
    return padding.left + padding.right !== 0;
  }
  function paddingToAttributes(padding) {
    return {
      paddingTop: `${padding.top}px`,
      paddingRight: `${padding.right}px`,
      paddingBottom: `${padding.bottom}px`,
      paddingLeft: `${padding.left}px`
    };
  }
  class BaseEditor extends Component {
    constructor(...args) {
      super(...args);
      this.onMouseDown = e => {
        e.stopPropagation();
      };
    }
    renderContent(divProps = {}) {
      const _this$props = this.props,
        {
          id,
          userHover,
          isSelectedRichText
        } = _this$props,
        propsForWidget = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsxs("div", Object.assign({
          className: `cos-${id}`,
          "data-selenium": `module-${id}`,
          "data-module-wrapper": "true"
        }, divProps, {
          children: [userHover && !isSelectedRichText && /*#__PURE__*/_jsx(AsyncElementToolbar, Object.assign({}, this.props)), /*#__PURE__*/_jsx(EditableElement, Object.assign({}, propsForWidget))]
        }))
      );
    }
    render() {
      const {
        isInFlexArea,
        isRenderedImage,
        paddingConfig,
        stack
      } = this.props;
      const usePaddingClass = hasHorizontalPadding(paddingConfig) && stack !== STACK.NONE;
      if (!isInFlexArea || isRenderedImage) {
        return this.renderContent({
          onMouseDown: this.onMouseDown
        });
      }
      return /*#__PURE__*/_jsx("table", {
        role: "presentation",
        cellPadding: "0",
        cellSpacing: "0",
        width: "100%",
        children: /*#__PURE__*/_jsx("tbody", {
          children: /*#__PURE__*/_jsx("tr", {
            children: /*#__PURE__*/_jsx("td", {
              className: usePaddingClass ? "hs_padded" : "",
              onMouseDown: this.onMouseDown,
              style: paddingToAttributes(paddingConfig),
              children: this.renderContent()
            })
          })
        })
      });
    }
  }
  BaseEditor.propTypes = {
    id: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    index: PropTypes.number,
    sectionIndex: PropTypes.number,
    columnIndex: PropTypes.number,
    html: PropTypes.string,
    renderedOutput: PropTypes.object,
    userHover: PropTypes.bool,
    isRenderedImage: PropTypes.bool,
    isInFlexArea: PropTypes.bool.isRequired,
    paddingConfig: PropTypes.object,
    element: PropTypes.object,
    canDeleteElement: PropTypes.bool,
    canCloneElement: PropTypes.bool,
    isSelectedRichText: PropTypes.bool.isRequired,
    setIsHoveringSubSection: PropTypes.func,
    stack: PropTypes.string
  };
  return connect(mapStateToProps)(BaseEditor);
}